// Uchal.jsx ✅ updated with i18n (translations) + logic same
import React, { useEffect, useRef, useState, useContext } from 'react'
import './Uchal.css'
import cash from "../../imgs/cash.png";
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import date from "../../imgs/bdate.png";

import { useTranslation } from "react-i18next";

const Uchal = (props) => {
    const inputRefs = useRef([]);
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({ date: new Date().toISOString().substr(0, 10), kno: "", name: "", type: "", amt: "", remark: "", tamt: "" });
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [dates, setDates] = useState({ date1: "", date2: new Date().toISOString().substr(0, 10) });
    const [khnames, setKhnames] = useState([]);
    const [value, setValue] = useState('');
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [stock, setStock] = useState();
    const [sredit, setSredit] = useState('');
    const refprint2 = useRef(null);
    const refprint2close = useRef(null);
    const [srdelete, setSrdelete] = useState('');
    const refdelete = useRef(null);
    const refdeleteclose = useRef(null);
    const [wait, setWait] = useState(false);
    const { sanksource, setSanksource, setHeadname } = useContext(Globalcontext);
    const today = new Date().toISOString().split('T')[0];
    const { submenu, setsubmenu, newcustsource, setNewcustsource, custlist, setCustlist } = useContext(Globalcontext);

    const [t] = useTranslation();

    function handleEnterKey(event, currentIndex) {
        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }

        // keep as-is (existing Marathi string)
        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा')
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if (
                        (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
                        prevElement !== event.target
                    ) {
                        prevElement.focus();
                        break;
                    } else {
                        prevIndex--;
                    }
                } else {
                    prevIndex--;
                }
            }
        }
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        }).replace(/ /g, '-');
    };

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));

        if (name === 'date') {
            if (value === "" || value === "dd/mm/yyyy" || value > today) {
                setInput(prevInput => ({
                    ...prevInput,
                    date: prevInput.date && prevInput.date <= today ? prevInput.date : today
                }));
                return;
            }
        }
    }

    useEffect(() => {
        if (input.kno === "") {
            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                name: "",
                type: "",
                amt: "",
                remark: "",
            }))
            setNewedit("new");
        }
        else {
            let custlisttemp = JSON.parse(localStorage.getItem("custlist"));
            for (let i = 0; i < custlisttemp.length; i++) {
                setInput(prevInput => ({ ...prevInput, name: '' }));
                const user = custlisttemp[i];
                if (user.kno === input.kno) {
                    setInput(prevInput => ({ ...prevInput, name: user.cname }));
                    break;
                }
            }
        }
    }, [input.kno])

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            event.preventDefault();
            saveuchal();
            let nextIndex = null;
            if (currentIndex === 0) {
                nextIndex = (input.name !== "") ? currentIndex + 1 : currentIndex;
            } else {
                nextIndex = currentIndex + 1;
            }
            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[4]) inputRefs.current[4].focus();
            }
        }
    }

    const saveuchal = () => {
        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);

        if (input.date === "" || input.kno === "" || input.name === "" || !input.type || input.amt === "" || input.remark === "") {
            notifyerror(t("uchal.toast.incomplete"));
            setWait(false);
            return;
        }

        let rawData = {
            date: input.date,
            date1: dates.date1,
            date2: dates.date2,
            kno: input.kno,
            type: input.type, // keep excellentdairy string
            amt: input.amt,
            remark: input.remark,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            flag: newedit,
            sredit: sredit,
        }

        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/saveuchal2.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (newedit === "new") {
                if (response.data.trim() === "Saved.") {
                    notify(t("uchal.toast.saved"));
                    setWait(false);
                }
            } else {
                if (response.data.trim() === "updated.") {
                    notify(t("uchal.toast.updated"));
                    setWait(false);
                }
            }

            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                type: "",
                amt: "",
                remark: "",
            }))
            setSredit("");
            setNewedit("new");
            getuchal(dates.date1, dates.date2);
            if (inputRefs.current[1]) inputRefs.current[1].focus();

        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    useEffect(() => {
        const currentDate1 = new Date(dates.date1);
        const dayOfMonth1 = currentDate1.getDate();
        const currentMonth1 = currentDate1.getMonth();
        const currentYear1 = currentDate1.getFullYear();

        let lastDayOfMonth1;

        if (localStorage.getItem("dur") === '10') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) lastDayOfMonth1 = 10;
            else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) lastDayOfMonth1 = 20;
            else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 31) lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
        } else if (localStorage.getItem("dur") === '15') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) lastDayOfMonth1 = 15;
            else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 31) lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
        }

        if (lastDayOfMonth1 !== undefined) {
            const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
            setDates(prevInput => ({ ...prevInput, date2: formattedDate2 }));
        }
    }, [dates.date1]);

    useEffect(() => {
        const currentDate1 = new Date(input.date);
        const dayOfMonth1 = currentDate1.getDate();
        const currentMonth1 = currentDate1.getMonth();
        const currentYear1 = currentDate1.getFullYear();

        let lastDayOfMonth1, firstday;

        if (localStorage.getItem("dur") === '10') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) { firstday = "1"; lastDayOfMonth1 = 10; }
            else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) { firstday = "11"; lastDayOfMonth1 = 20; }
            else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) { firstday = "21"; lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); }
        } else if (localStorage.getItem("dur") === '15') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) { firstday = "1"; lastDayOfMonth1 = 15; }
            else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 30) { firstday = "16"; lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); }
        }

        if (lastDayOfMonth1 !== undefined) {
            const formattedDate1 = new Date(currentYear1, currentMonth1, firstday).toLocaleDateString('en-CA');
            const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
            setDates(prevInput => ({ ...prevInput, date1: formattedDate1, date2: formattedDate2 }));
        }
    }, [input.date]);

    useEffect(() => {
        if (inputRefs.current[1]) inputRefs.current[1].focus();

        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        let firstDayOfMonth;
        let lastDayOfMonth;

        if (localStorage.getItem("dur") === '10') {
            if (dayOfMonth >= 1 && dayOfMonth <= 10) { firstDayOfMonth = 1; lastDayOfMonth = 10; }
            else if (dayOfMonth >= 11 && dayOfMonth <= 20) { firstDayOfMonth = 11; lastDayOfMonth = 20; }
            else if (dayOfMonth >= 21 && dayOfMonth <= 31) { firstDayOfMonth = 21; lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); }
        } else if (localStorage.getItem("dur") === '15') {
            if (dayOfMonth >= 1 && dayOfMonth <= 15) { firstDayOfMonth = 1; lastDayOfMonth = 10; }
            else if (dayOfMonth >= 16 && dayOfMonth <= 31) { firstDayOfMonth = 16; lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); }
        }

        if (firstDayOfMonth !== undefined && lastDayOfMonth !== undefined) {
            const formattedDate1 = new Date(currentYear, currentMonth, firstDayOfMonth).toLocaleDateString('en-CA');
            const formattedDate2 = new Date(currentYear, currentMonth, lastDayOfMonth).toLocaleDateString('en-CA');
            setDates(prevInput => ({ ...prevInput, date1: formattedDate1, date2: formattedDate2 }));
            getuchal(formattedDate1, formattedDate2);
        }
    }, [])

    const setNewPeriod = async () => {
        getuchal(dates.date1, dates.date2)
    }

    const handleChangedates = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setDates(value => ({ ...value, [name]: valuecurrent }));
    }

    async function getuchal(date1, date2) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getuchaldate.php', { date1: date1, date2: date2, date: input.date, time: input.time, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data.length > 0) {
                setDataSource(response.data);
                setInput(value => ({ ...value, tamt: response.data[0].tamt }));
                setTimeout(() => props.setProgress(100), 200);
                handleprintclose();
            } else {
                setDataSource([]);
                setInput(value => ({ ...value, tamt: "0" }));
                handleprintclose();
            }
        }).catch(err => {
            console.log(err);
            handleprintclose();
        });
    }

    const handleedit = (sr, date, kno, type, amt, remark) => {
        setInput(prevInput => ({
            ...prevInput,
            sr: sr, date: date, kno: kno, type: type, amt: amt, remark: remark
        }))
        setNewedit("edit");
        setSredit(sr);
    }

    async function deleteuchal() {
        handleDeleteclose();
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/deleteuchal.php', { sr: srdelete, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                notify(response.data); // keep excellentdairy message
                setInput(prevInput => ({
                    ...prevInput,
                    kno: "",
                    name: "",
                    type: "",
                    amt: "",
                }))
                setSredit("");
                setNewedit("new");
                setSrdelete("");
                getuchal(dates.date1, dates.date2);
                if (inputRefs.current[1]) inputRefs.current[1].focus();
            }
        }).catch(err => console.log(err));
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    const handleprintclose = () => {
        refprint2close.current.click();
    }

    const handlePrint = () => {
        refprint2.current.click();
    }

    const handleDeleteclose = () => {
        setSrdelete("");
        refdeleteclose.current.click();
    }

    const handleDelete = (sr) => {
        setSrdelete(sr);
        refdelete.current.click();
    }

    const openkarj = () => {
        setsubmenu("karj");
        setHeadname(t("uchal.head.loan_dept"));
    };

    // print
    const cellStyle = { border: '1px solid black', padding: '4px' };

    const printUchal = () => {
        const content = document.getElementById('print-receipt-uchal');
        const kendraTitle = localStorage.getItem('kendra') || '';
        const kno = input.kno || '';
        const name = input.name || '';
        const dt = input.date || '';
        const type = input.type || '';
        const amt = input.amt || '';
        const remark = (input.remark && input.remark !== "") ? input.remark : "-";

        if (!content) {
            alert("Print section not found!");
            return;
        }

        const printWindow = window.open('', '', 'width=300,height=500');
        printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          @page { size: 58mm auto; margin: 0; }
          body { margin: 0; font-family: sans-serif; font-size: 12px; }
          .center-title { text-align: center; font-size: 11px; font-weight: bold; margin: 6px 0 2px; }
          .subinfo { font-size: 9px; font-weight: bold; margin-left: 1px; margin-bottom: 6px; line-height: 1.4; }
          .subinfo-row { display: flex; justify-content: space-between; margin-right: 6px; }
          table { border-collapse: collapse; width: 100%; margin-top: 10px; }
          th, td { border: 2px solid black; padding: 4px; text-align: center; }
          .thanks { text-align: center; font-weight: bold; font-size: 10px; margin-top: 12px; }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <div class="center-title">${kendraTitle}</div>

        <div class="subinfo">
          <div class="subinfo-row">
            <span>${t("uchal.print.acc_no")}: ${kno}</span>
            <span>${t("uchal.print.date")}: ${dt}</span>
          </div>
          <div>${t("uchal.print.name")}: ${name}</div>
          <div class="subinfo-row">
            <span>${t("uchal.print.type")}: ${type}</span>
            <span>${t("uchal.print.amount")}: ₹${amt}</span>
          </div>
          <div>${t("uchal.print.remark")}: ${remark}</div>
        </div>

        ${content.innerHTML}

        <div class="thanks">---------</div>
        <div class="thanks">${t("uchal.print.thanks")}</div>
      </body>
    </html>
  `);
        printWindow.document.close();
    };

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refprint2}
                data-bs-target="#uchalperiod"
            />

            <div className="modal fade" id="uchalperiod" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprint2close} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h5 className="modal-title" id="exampleModalLabel">{t("uchal.modal.period_title")}</h5>

                            <div className="rowbill">
                                <div className="mb-2">
                                    <span className='subheadsank'>{t("common.date")}</span>
                                    <input onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="date" className="form-control" autoComplete='off' id="date1" name="date1" value={dates.date1} onChange={handleChangedates} />
                                </div>

                                <span className='subheadbill'>{t("common.to")}</span>

                                <div className="mb-2">
                                    <span className='subheadsank'>{t("common.date")}</span>
                                    <input disabled onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="date" className="form-control" autoComplete='off' id="date2" name="date2" value={dates.date2} onChange={handleChangedates} />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>{t("common.close")}</button>
                            <button type="button" className="btn btn-danger" onClick={setNewPeriod} >{t("common.ok")}</button>
                        </div>
                    </div>
                </div>
            </div>

            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refdelete}
                data-bs-target="#deleteuchal"
            />

            <div className="modal fade" id="deleteuchal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h5 className="modal-title" id="exampleModalLabel">{t("uchal.modal.delete_title")}</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleDeleteclose}>{t("common.close")}</button>
                            <button type="button" className="btn btn-danger" onClick={deleteuchal} >{t("common.yes")}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="khadyamain">
                <div className="firstrowkhadya">
                    <img onClick={props.visibility} className='back' src={back} alt="" />
                    <div className="colmainkhadya">
                        <div className="firstrow2">
                            <div className="row1kh100">
                                <div className="mb-2">
                                    <span className='subheadsank'>{t("common.date")}</span>
                                    <input onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="date" className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"} autoComplete='off' id="date" name="date" value={input.date} onChange={handleChange} />
                                </div>

                                <div className="rightkhsaletop">
                                    {localStorage.getItem("karj") === "On" ? (
                                        <div className="autoboxuchal">
                                            <button onClick={openkarj} id='savesank' type="submit" className="btn btn-success mx-1 sanksmall">
                                                {t("uchal.head.loan_dept")}
                                            </button>
                                        </div>
                                    ) : ''}

                                    <div onClick={handlePrint}>
                                        <img className='khadyaicon' src={date} alt="" />
                                        <span className='khsaleblack'>
                                            {t("uchal.text.period")} :
                                            <span className='khsaleblue'>
                                                {formatDate(dates.date1) + " " + t("common.to") + " " + formatDate(dates.date2)}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='linekh' />

                <div className="row1uchal">
                    <div className="mb-2">
                        <span className='subheadsank'>{t("uchal.labels.account_no")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="number" className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"} autoComplete='off' id="kno" name="kno" value={input.kno} onChange={handleChange} />
                    </div>
                    <div className="mb-2">
                        <span className='subheadsank'>{t("uchal.labels.member_name")}</span>
                        <input type="text" disabled className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="name" name="name" value={input.name} onChange={handleChange} />
                    </div>
                </div>

                <div className='linekh' />

                <div className="row1uchal">
                    <div className="mb-2">
                        <span className='subheadsank'>{t("uchal.labels.type")}</span>
                        <select
                            onKeyDown={e => handleEnterKey(e, 2)}
                            ref={ref => (inputRefs.current[2] = ref)}
                            value={input.type || ""}   // keep value as Debit/Credit
                            name="type"
                            id="type"
                            onChange={handleChange}
                            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        >
                            <option value="">{t("uchal.placeholders.select_type")}</option>
                            <option value="Debit">{t("uchal.type.debit_label")}</option>
                            <option value="Credit">{t("uchal.type.credit_label")}</option>
                        </select>

                    </div>

                    <div className="mb-2">
                        <span className='subheadsank'>{t("uchal.labels.amount")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 3)} ref={ref => (inputRefs.current[3] = ref)} type="number" className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"} autoComplete='off' id="amt" name="amt" value={input.amt} onChange={handleChange} />
                    </div>

                    <div className="mb-2">
                        <span className='subheadsank'>{t("uchal.labels.remark")}</span>
                        <input type="text" onKeyDown={e => handleEnterKey(e, 4)} ref={ref => (inputRefs.current[4] = ref)} className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="remark" name="remark" value={input.remark} onChange={handleChange} />
                    </div>
                </div>

                <div className="row1uchal2">
                    <div className="mb-2">
                        <div className="row1uchal2">
                            <div className="row1khsale">
                                {wait ? (
                                    <button type="submit" className="btn btn-primary mx-1 sanksmall">
                                        {t("common.loading")}
                                    </button>
                                ) : (
                                    <button onClick={saveuchal} onKeyDown={e => handleEnterKeybutton(e, 0)} ref={ref => (inputRefs.current[5] = ref)} type="submit" className="btn btn-primary mx-1 sanksmall">
                                        {newedit === "new" ? t("common.save") : t("common.update")}
                                    </button>
                                )}

                                <button type="submit" className="btn btn-primary mx-1 sanksmall">{t("uchal.buttons.sale_list")}</button>

                                <button type="button" className="btn btn-primary mx-1 sanksmall" onClick={printUchal}>
                                    {t("common.print")}
                                </button>
                            </div>

                            <div className="rightkhsale">
                                <img className='khadyaicon' src={cash} alt="" />
                                <span className='uchalblack'>
                                    {t("uchal.summary.amount")} :
                                    <span className='khsalered'>₹{parseFloat(input.tamt).toFixed(2)}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="firstrow2">
                    <div className="table-containeruchal">
                        <table id="myTable" className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className='thsmall' scope="col">{t("uchal.table.sr")}</th>
                                    <th className='thsmall' scope="col">{t("uchal.table.date")}</th>
                                    <th className='thsmall' scope="col">{t("uchal.table.acc_no")}</th>
                                    <th className='thlarge' scope="col">{t("uchal.table.name")}</th>
                                    <th className='thsmall' scope="col">{t("uchal.table.type")}</th>
                                    <th className='thsmall' scope="col">{t("uchal.table.amount")}</th>
                                    <th className='thsmall' scope="col">{t("uchal.table.action")}</th>
                                </tr>
                            </thead>

                            <tbody>
                                {value.length > 0
                                    ? tableFilter.map((user, index) =>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{user.date}</td>
                                            <td>{user.kno}</td>
                                            <td>{user.name}</td>
                                            <td>{user.type}</td>
                                            <td>{user.amt}</td>
                                        </tr>
                                    )
                                    : DataSource.map((user, index) =>
                                        <tr key={index}>
                                            <td className='thsmallaudit'>{index + 1}</td>
                                            <td className='thsmallaudit'>{user.date}</td>
                                            <td className='thsmallaudit'>{user.kno}</td>
                                            <td className='thsmallaudit'>{user.name}</td>
                                            <td className='thsmallaudit'>{user.type}</td>
                                            <td className='thsmallaudit'>{user.amt}</td>
                                            <td>
                                                <UilEditAlt onClick={() => { handleedit(user.sr, user.date, user.kno, user.type, user.amt, user.remark) }} className="icsank" />
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="print-receipt-uchal" style={{ display: 'none' }}>
                    <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '12px', textAlign: 'center' }}>
                        <thead>
                            <tr>
                                <th style={cellStyle}>{t("uchal.print_table.type")}</th>
                                <th style={cellStyle}>{t("uchal.print_table.amount")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={cellStyle}>{input.type}</td>
                                <td style={cellStyle}>₹{input.amt}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ToastContainer />
            </div>
        </>
    )
}

export default Uchal
